module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAgCAYAAADwvkPPAAAAAXNSR0IArs4c6QAAAV1JREFUSEut1k9LFVEYx/Hv8+bcCOJGCSWTxMKwJCkxFEGMQqVQI9FQrFBauG/TroXvQDeC7yB6CV+5MvfSvc6/M9Msz8x8eJ4zc37nBC0udSwizrtENLXUB8APYCgifnWcRpg6CZxmhfwBRiLiIhlTp4BvAx1dA+NJmDoNnORMzWUSps4AR4VQxFWtytQnwGEZVOsDqHPAfhVUianzwKc6UCmmvgB260KFmPoS+JgC5WLqK2A7FbqHqUvAZhOoD1PfAO+aQj1MXQU22kB3mLoGrLeF/j/WEdUV4G3b6nprU10G3rcB+xa6+hrYagreSw11EfjQBMyNIHUB2EkFC/NMfQ7spYCl4ag+Az7XBSuTVn0KHNQBK7HsP5wFvlSBtbAMfAwcl4G1sQx8BHwtBHNulA6pD4HvAw/dJO2b/76sTgBn2dhfYDQifie1OQB2Dy7DEfEzdw9IaXvwSHUL1gq2zOmUQj4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/gd/detail7.png
// module id = Otpf
// module chunks = 1